module.exports = __webpack_public_path__ + "static/adminfeatfree-8ee16f0b917d243df5edabaa47afc788.png";